import en from './locale/en';
import ur from './locale/ur';
import ar from './locale/ar';

export default {
  en,
  ur,
  ar,
};
